export default __webpack_public_path__ + "static/media/tl.0d454090.svg";